/* eslint-disable */
/* tslint:disable */

/**
 * Base files
 */
export const createApp = require('@/main').default;
export const createRouter = require('@/router').default;
export const createStore = require('@/store').default;

/**
 * Plugins system
 */
const plugins = {};


export const pluginsInit = async (context) => {
  
};
